import globalConfig from '@alife/iot-vapp-global-config';
var ASSETS_PATH = "https://" + (globalConfig.env === 'daily' ? 'dev.' : '') + "g.alicdn.com/iotx-studio-fe/studio-assets/0.0.4/icon/";
export var LIBRARY_LIST = [{
        key: 'aliyun',
        name: '阿里云',
        scriptUrl: ASSETS_PATH + "aliyun.js",
        previewUrl: 'https://img.alicdn.com/imgextra/i3/O1CN01xNBhkf1jhgdu2HTcP_!!6000000004580-2-tps-188-188.png',
    }, {
        key: 'aliintl',
        name: '阿里巴巴国际站',
        scriptUrl: ASSETS_PATH + "aliintl.js",
        previewUrl: 'https://img.alicdn.com/imgextra/i3/O1CN01rtU49C1USpYcoGEMm_!!6000000002517-2-tps-188-188.png',
    }, {
        key: 'aliiot',
        name: '阿里云控制台',
        scriptUrl: ASSETS_PATH + "aliiot.js",
        previewUrl: 'https://img.alicdn.com/imgextra/i3/O1CN01uzVqkT1ZnVWHZOeYr_!!6000000003239-2-tps-380-376.png',
    }, {
        key: 'alihealth',
        name: '阿里健康',
        scriptUrl: ASSETS_PATH + "alihealth.js",
        previewUrl: 'https://img.alicdn.com/imgextra/i2/O1CN01U1CMN01tEVZ9gDTXk_!!6000000005870-2-tps-190-190.png',
    }, {
        key: 'antd',
        name: 'Ant Design',
        scriptUrl: ASSETS_PATH + "antd.js",
        previewUrl: 'https://img.alicdn.com/imgextra/i4/O1CN01Y2d4nq1vhwFPXhG80_!!6000000006205-2-tps-188-190.png',
    }, {
        key: 'cainiao',
        name: '菜鸟',
        scriptUrl: ASSETS_PATH + "cainiao.js",
        previewUrl: 'https://img.alicdn.com/imgextra/i1/O1CN01Od6BUB1U7lL8Mc8eN_!!6000000002471-2-tps-188-190.png',
    }, {
        key: 'etao',
        name: '一淘无线',
        scriptUrl: ASSETS_PATH + "etao.js",
        previewUrl: 'https://img.alicdn.com/imgextra/i4/O1CN01aWG0Iz1FU0L1mFry3_!!6000000000489-2-tps-186-186.png',
    }, {
        key: 'fliggy',
        name: '飞猪',
        scriptUrl: ASSETS_PATH + "fliggy.js",
        previewUrl: 'https://img.alicdn.com/imgextra/i4/O1CN01HqnS5F1bvPaFq2Vao_!!6000000003527-2-tps-190-188.png',
    }, {
        key: 'rookie3',
        name: 'Rookie 3.0',
        scriptUrl: ASSETS_PATH + "rookie3.js",
        previewUrl: 'https://img.alicdn.com/imgextra/i1/O1CN015YW8qF1OiVQ8LDqOH_!!6000000001739-2-tps-186-188.png',
    }, {
        key: '1688',
        name: '1688',
        scriptUrl: ASSETS_PATH + "1688.js",
        previewUrl: 'https://img.alicdn.com/imgextra/i3/O1CN01c8MvqV1kF7YNTS1Ot_!!6000000004653-2-tps-192-190.png',
    }];
